import { EditorWorkspacePage } from '@jarvis/platform-ui';

export function WorkspacePage() {
  return <EditorWorkspacePage filesLinkTo="/files" filesLinkLabel="File Browser" />;
}
